
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiPriceRules } from "@/core/api";
import Swal from "sweetalert2/dist/sweetalert2.js";
import mixin from "@/mixins";

export default defineComponent({
  name: "add-channel-modal",
  components: {},
  emits: ["update-list"],
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const addDistributionPriceRulesModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);

    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      name: "", //非必须
      description: "", //非必须
      from_date: "", // 非必须
      to_date: "", //非必须
      is_active: 0, //非必须 no:0,yes:1
      discard_subsequent_rules: 0, // 非必须 no:0,yes:1
      conditions_serialized: "", //非必须
      sorting: "", //非必须
      action: "", //非必须 默认值:0, Percent:1,Amount:2
      value: "", // 非必须
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "Name is required",
          trigger: "change",
        },
      ],
      action: [
        {
          required: true,
          message: "Action is required",
          trigger: "change",
        },
      ],
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiPriceRules.addPriceRules(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addDistributionPriceRulesModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const handleDiscard = () => {
      hideModal(addDistributionPriceRulesModalRef.value);
      resetForm();
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    return {
      loading,
      formData,
      rules,
      formRef,
      addDistributionPriceRulesModalRef,
      submitButton,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
